import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import {
  Polygon,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsx(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: /* @__PURE__ */ jsx(
        Polygon,
        {
          points: "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2",
          stroke: `${color}`
        }
      )
    }
  );
};
Icon.displayName = "Octagon";
const Octagon = memo(themed(Icon));
export {
  Octagon
};
//# sourceMappingURL=octagon.js.map
